import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFacultyItems } from '@redturtle/volto-io-studio/actions';
import { FacultyCard } from '@redturtle/volto-io-studio/components/';
import { flattenToAppURL } from '@plone/volto/helpers';
import { useIntl, defineMessages } from 'react-intl';
import { Container } from 'semantic-ui-react';
import cx from 'classnames';
import { NoResults } from '@redturtle/volto-io-studio/components/';

import './facultyBlock.less';

const View = (props) => {
  const { data, className } = props;
  const dispatch = useDispatch();

  const navroot = useSelector(
    (state) => state.content.data?.['@components']?.navroot,
  );
  const items = useSelector((state) => {
    // professors deve diventare items
    return state.facultyItems?.result?.professors;
  });
  useEffect(() => {
    navroot?.navroot &&
      dispatch(getFacultyItems(flattenToAppURL(navroot.navroot['@id'])));
  }, [dispatch, navroot]);

  return items && items.length > 0 ? (
    <div className={cx('faculty-block full-width ', className)}>
      <Container>
        {data?.title && <h2 className="title">{data?.title}</h2>}

        <div className={cx('faculty-wrapper', data.column + '-columns')}>
          {items?.map((item) => (
            <FacultyCard item={item} key={item.fullname} />
          ))}
        </div>
      </Container>
    </div>
  ) : props.editable ? (
    <NoResults />
  ) : (
    <></>
  );
};

View.propTypes = {};

export default View;
